export default "__VITE_ASSET__d1RSDuG6__"